/* tslint:disable */
/* eslint-disable */
export enum EntityType {
  Ic = 'IC',
  Ho = 'HO',
  Si = 'SI',
  Ki = 'KI',
  O = 'O'
}
